import { TEXT_SDQ_REPORT } from 'constants/string/texts';

import SdqSectionTitleBar from './SdqSectionTitleBar';

const ApprovalDelegation = require('assets/resources/ApprovalDelegation.svg').default;

/**
 * 頑張っていること / これからのびる力: per subscale, the characteristic text, the
 * 対処法 text and the behaviours that go with it.
 *
 * The guardian app links each behaviour to the topic search; the admin has no
 * such screen, so the behaviours are rendered as plain text.
 */
const SdqRiskDetailSection = (props) => {
  const { sectionData, title, titleClassName, solutionLabel, behaviorFooter } = props;

  return (
    <div className="mt-6 space-y-3">
      <SdqSectionTitleBar className={titleClassName}>
        <p className="font-bold text-black-102">{title}</p>
      </SdqSectionTitleBar>
      <div className="space-y-4 text-sm text-black-102">
        {sectionData.items.map((item) => (
          <div key={item.subscaleKey} className="space-y-3">
            <p className="font-bold">{TEXT_SDQ_REPORT.SUBSCALE_DETAIL[item.subscaleKey] ?? item.subscaleLabel ?? item.subscaleKey}</p>
            {item.characteristicHtml && <div dangerouslySetInnerHTML={{ __html: item.characteristicHtml }} />}
            {(item.solutionHtml || item.behaviors.length > 0) && (
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <img className="w-5 h-5 shrink-0 brightness-0" src={ApprovalDelegation} alt="" aria-hidden width={20} height={20} />
                  <p className="font-bold">{solutionLabel}</p>
                </div>
                {item.solutionHtml && <div dangerouslySetInnerHTML={{ __html: item.solutionHtml }} />}
                {item.behaviors.length > 0 && (
                  <div className="space-y-2">
                    <ul className="space-y-2">
                      {item.behaviors.map((behavior, index) => (
                        <li key={`${item.subscaleKey}-${index}`}>
                          <span className="inline-block px-1">•</span>「{behavior}」
                        </li>
                      ))}
                    </ul>
                    <p>{behaviorFooter}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SdqRiskDetailSection;
